module.exports = "https://coursera_assets.s3.amazonaws.com/images/f0929f31f826b1f687f4d68cdb73ea70.png";